<template>
  <div class="input-hidden" :class="wrapperClasses">
    <input type="hidden" value="text"/>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseInput from "@/components/Base/Controls/BaseInput";

export default {
  name: "InputHiddenControl",
  components: {
    BaseInput
  },
  extends: BaseFormControl,
  props: {},
  data() {
    return {
      text: this.value
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.text = newValue;
      }
    }
  }
};
</script>
